import { useRef, useState, useEffect } from 'react';
import Human from '@vladmandic/human';
import axios from 'axios';
import { useFormContext } from "react-hook-form";

import captureImg from '../../capture.jpeg'


function Camera({ details }) {
    const { register, watch, setValue, formState: { errors } } = useFormContext();
    const width = 320;
    const height = 320;
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [human, setHuman] = useState(null);
    const [capturedImage, setCapturedImage] = useState(null);
    const [webCamCurrentStatus, setWebCamCurrentStatus] = useState(null);
    const [faceType, setFaceType] = useState('');

    const [imageUrl, setimageUrl] = useState('');

    const myConfig = {
        debug: true,
        backend: 'webgl',
        useTFWasmBackend: true,
        modelBasePath: './models',
        segmentation: { enabled: false },
        filter: { enabled: true, equalization: false, flip: false },
        face: {
            enabled: true,
            detector: { rotation: true },
            mesh: { enabled: true },
            attention: { enabled: false },
            iris: { enabled: true },
            description: { enabled: true },
            emotion: { enabled: true },
            antispoof: { enabled: true },
            liveness: { enabled: true }
        },
        body: { enabled: false },
        hand: { enabled: false },
        object: { enabled: false },
        gesture: { enabled: true }
    };

    useEffect(() => {
        const loadHuman = async () => {
            const humanInstance = new Human(myConfig);
            await humanInstance.load();
            await humanInstance.warmup();
            await webCam(humanInstance);
            setHuman(humanInstance);

            // Start the webcam stream
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ video: true })
                    .then(stream => {
                        videoRef.current.srcObject = stream;
                        videoRef.current.play(); // Ensure the video starts playing
                    })
                    .catch(err => console.error("Error accessing camera: ", err));
            }
        };

        loadHuman();
    }, []);


    async function webCam(humanInstance) {
        try {
            const devices = await humanInstance.webcam.enumerate();
            const id = devices[0]?.deviceId;
            const webcamStatus = await humanInstance.webcam.start({
                element: document.getElementById('video'),
                crop: false,
                width,
                height,
                id: id || 'default',
            });
            setWebCamCurrentStatus(webcamStatus);
        } catch (err) {
            console.error('Error starting webcam: ', err);
        }
    }

    const captureImage = async () => {
        if (!human || !videoRef.current) return;

        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        const result = await human.detect(canvas);

        if (result.face.length > 0) {
            const face = result.face[0];
            const angle = face.rotation.angle;
            const yaw = angle.yaw ?? '';
            if (Math.abs(yaw) < 0.3 && Math.abs(yaw) > 0) {
                setFaceType('Front Face Detected');
            } else {
                setFaceType('Side Face Detected');
            }
            const capturedData = canvas.toDataURL('image/png');
            setCapturedImage(capturedData);
            const imageBlob = dataURLToBlob(capturedData);
            uploadCatureImg(imageBlob);
        } else {
            setFaceType('No Face Detected');
        }
    };

    function dataURLToBlob(dataURL) {
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }

        return new Blob([arrayBuffer], { type: mimeString });
    }
    function uploadCatureImg(imageBlob) {
        
        const currTime = new Date().toLocaleTimeString;

        const formData = new FormData();

        formData.append('faceRecognition', imageBlob, 'image_' + currTime + '.png');
        axios.post('https://staging.royahealth.app/api/facial-recognition', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                console.log('Image uploaded successfully', response.data);
                setValue(details.type, response.data);
            })
            .catch(error => {
                console.error('Error uploading image', error);
            });

    }
    return (
        <>

            <div className='mt-5 mb-10 font-mono text-2xl font-normal leading-8 text-center text-white w-full'>


                <div className='mb-10 bg-[#D9D9D9] p-5 text-black'>
                    <video ref={videoRef} width="320" height="320" autoPlay playsInline id="video" crossOrigin="anonymous" muted></video>
                    <div className='flex justify-center mt-2'>
                    <img className='rounded-[50%] cursor-pointer' onClick={captureImage} src={captureImg} alt="capture"  width="50" height="50"/>
                    </div>
                    
                    <canvas ref={canvasRef} width="160" height="160" style={{ display: 'none' }}></canvas>

                    {capturedImage && (
                        <div>
                            <p>{faceType}</p>
                           <div className='flex justify-center'>
                           <img src={capturedImage} alt="Captured Face"  width="160" height="160"/>
                           </div>
                        </div>
                    )}
                    {/* <p>{webCamCurrentStatus}</p> */}
                </div>

                <input type="text" hidden {
                    ...register(details.type, {
                        required: 'Please Capture Image',
                        value: imageUrl
                        })}>
                </input>
                {
                    errors[details.type]?.message && (
                        <p role="alert" className="text-red-500 mt-2">
                            {errors[details.type]?.message}
                        </p>
                    )
                }
                    




                <h1 className="font-inter text-[26px] font-bold leading-[32.5px] text-center text-white">
                    {details.title}
                </h1>
                <h6 className="font-inter text-[20px] font-bold leading-[25px] text-center text-white">{details.subTitle}</h6>

            </div>
        </>
    )
}
export default Camera;


